export default {
  inject: ['load'],
  data() {
    return { numOfCurrentMissions: null };
  },
  methods: {
    get115DashboardFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDashboard115').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          let temp = this.$store.state.dashboardModule.dashboard115;
          this.ready115Dashboard(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.get115DashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    get800DashboardFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDashboard800').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          let temp = this.$store.state.dashboardModule.dashboard800;
          this.ready800Dashboard(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.get800DashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getDoctorDashboardFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDashboardDoctor').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          let temp = this.$store.state.dashboardModule.dashboardDoctor;
          this.readyDotorDashboard(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getDoctorDashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAdmissionDashboardFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDashboardAdmission').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          let temp = this.$store.state.dashboardModule.dashboardAdmission;
          this.readyAdmissionDashboard(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAdmissionDashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getQCDashboardFunction: function (params) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getDashboardQC', params).then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          let temp = this.$store.state.dashboardModule.dashboardQC;
          this.readyQCDashboard(temp);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getQCDashboardFunction(params);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getQCUser115DashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQcUser115Dashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCUser115;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCUser115DashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCUser800DashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQcUser800Dashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCUser800;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCUser800DashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCUserTechnicianDashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQcUserTechnicianDashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCUserTechnician;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCUserTechnicianDashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCUserDoctorDashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQcUserDoctorDashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCUserDoctor;
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCUserDoctorDashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => (this.load.val = false));
    },
    getQCUserAdmissionDashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQcUserAdmissionDashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCUserAdmission;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCUserAdmissionDashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getQCCheckListDashboardFunction: function (fromDate, toDate, userId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getQCCheckListDashboard', {
          fromDate: fromDate,
          toDate: toDate,
          userId: userId,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardQCCheckList;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getQCCheckListDashboardFunction(fromDate, toDate, userId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    getStatisticsMainDashboardFunction: function (fromDate, toDate) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getStatisticsMainDashboard', {
          fromDate: fromDate,
          toDate: toDate,
        })
        .then(() => {
          if (this.$store.state.dashboardModule.successFlag) {
            let temp = this.$store.state.dashboardModule.dashboardStatisticsMain;
            if (this.load.val) {
              this.load.val = false;
            }
            this.readyDashboard(temp);
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.dashboardModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getStatisticsMainDashboardFunction(fromDate, toDate);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    //115
    getNumberOfCurrentMissionsDashboardFunction: function () {
      return this.$store.dispatch('getNumberOfCurrentMissionsDashboard').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          return this.$store.state.dashboardModule.numberOfCurrentMissions;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {

            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getNumberOfCurrentMissionsDashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dashboardModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getNumberOfCurrentMissionsDashboardFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    //800
    getVehiclesReadinessFunction: function () {
      return this.$store.dispatch('getVehiclesReadinessDashboard').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          return this.$store.state.dashboardModule.vehiclesReadiness;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {

            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getVehiclesReadinessFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dashboardModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getVehiclesReadinessFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAwaitingMissionsFunction: function () {
      return this.$store.dispatch('getAwaitingMissionsDashboard').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          return this.$store.state.dashboardModule.awaitingMissions;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {

            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getAwaitingMissionsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dashboardModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getAwaitingMissionsFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getCurrentMissionsByRankFunction: function () {
      return this.$store.dispatch('getCurrentMissionsByRankDashboard').then(() => {
        if (this.$store.state.dashboardModule.successFlag) {
          return this.$store.state.dashboardModule.currentMissionsByRank;
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.dashboardModule.errorStatus) {

            return this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                return this.getCurrentMissionsByRankFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.dashboardModule.error400) {
            return this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                return this.getCurrentMissionsByRankFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },

    showError: function () {
      const errorText = this.$store.state.dashboardModule.error;
      this.showErrorAlert(errorText);
    },
  },
};
